'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$002dAccount$002dName$0024$0024anon$0024167 from "./presto.types$-Account-Name$$anon$167.js";
var $p;
/** @constructor */
function $c_Lpresto_types$AccountName$() {
  this.c42 = null;
  this.c43 = false;
  this.c40 = null;
  this.c41 = false;
  this.c44 = null;
  this.c45 = false;
}
export { $c_Lpresto_types$AccountName$ as $c_Lpresto_types$AccountName$ };
$p = $c_Lpresto_types$AccountName$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$AccountName$;
/** @constructor */
function $h_Lpresto_types$AccountName$() {
}
export { $h_Lpresto_types$AccountName$ as $h_Lpresto_types$AccountName$ };
$h_Lpresto_types$AccountName$.prototype = $p;
$p.cs3 = (function() {
  if ((!this.c43)) {
    this.c42 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Encoder$().aC;
    this.c43 = true;
  }
  return this.c42;
});
$p.ads = (function() {
  if ((!this.c41)) {
    this.c40 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().aa;
    this.c41 = true;
  }
  return this.c40;
});
$p.cIZ = (function() {
  if ((!this.c45)) {
    this.c44 = new $j_presto$002etypes$0024$002dAccount$002dName$0024$0024anon$0024167.$c_Lpresto_types$AccountName$$anon$167(this);
    this.c45 = true;
  }
  return this.c44;
});
var $d_Lpresto_types$AccountName$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$AccountName$, "presto.types$AccountName$", ({
  Ys: 1,
  D: 1
}));
export { $d_Lpresto_types$AccountName$ as $d_Lpresto_types$AccountName$ };
var $n_Lpresto_types$AccountName$;
function $m_Lpresto_types$AccountName$() {
  if ((!$n_Lpresto_types$AccountName$)) {
    $n_Lpresto_types$AccountName$ = new $c_Lpresto_types$AccountName$();
  }
  return $n_Lpresto_types$AccountName$;
}
export { $m_Lpresto_types$AccountName$ as $m_Lpresto_types$AccountName$ };
//# sourceMappingURL=presto.types$-Account-Name$.js.map
